import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../core/services/auth.service';
import {TokenService} from '../services/token.service';

@Component({
  selector: 'app-callback',
  imports: [],
  template: '',
})
export class CallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService
  ) {
  }

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.tokenService.setToken(token);
      if (this.authService.isAuthenticated()) {
        this.router.navigate(['/market']);
      } else {
        this.tokenService.removeToken();
      }
    } else {
      console.error('No token');
      this.router.navigate(['/login']);
    }
  }
}
